/* eslint-disable */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faMicrophoneSlash, faPhoneFlip } from '@fortawesome/pro-solid-svg-icons';

import { endCall, placeCall, toggleMute } from '../../actions/telephony';
import { prettifyPhone } from '../../common/utils/prettify';
import { sendSoftphoneStatus } from '../../utils/allow-nav';
import { getCookie } from '../../common/utils/cookie';
import { TPMODisclaimer } from '../../common/components';

import { MicTestButton } from '../../components';

import './styles.scss';

function MuteButton() {
  const { muted } = useSelector(store => store.telephony);
  return (
    <button
      className="btn btn-secondary rounded-circle me-2"
      style={{ width: '40px' }}
      onClick={toggleMute}
      title={muted ? 'Unmute' : 'Mute'}
    >
      <FontAwesomeIcon size={muted ? 'xs' : undefined} icon={muted ? faMicrophoneSlash : faMicrophone} />
    </button> 
  );
}

function CallButton() {
  const { phone } = useSelector(store => store.softphone);
  const { status } = useSelector(store => store.telephony);
  let addClasses = '';
  let disabled = false;

  if (status === 'connecting') {
    addClasses = 'animate-shake';
    disabled = true;
  } else if (status === 'connected') {
    disabled = true;
  }

  return (
    <button
      className="btn btn-success rounded-circle"
      style={{ width: '40px' }}
      onClick={() => placeCall(phone)}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={faPhoneFlip} className={addClasses} />
    </button> 
  );
}

function EndCallButton() {
  const { status } = useSelector(store => store.telephony);

  return (
    <button
      className="btn btn-danger rounded-pill"
      onClick={endCall}
      style={{ color: 'white' }}
      disabled={!((status === 'connected') || (status === 'connecting'))}
    >
      End call
    </button> 
  );
}

function Softphone() {
  const [disclaimerRead, setDisclaimerRead] = useState(false);
  const [effectiveDate, setEffectiveDate] = useState();
  const [countyFips, setCountyFips] = useState();
  const planYear = moment(effectiveDate).year();

  let { agentPortal: agentPortalUrl } = useSelector(store => store.theme);
  // below is to make this work on localhost dev server
  if (process.env.NODE_ENV === 'development') {
    agentPortalUrl = process.env.REACT_APP_AGENT_PORTAL_DEV_SERVER_URL;
  }

  const { phone, shopperName  } = useSelector(store => store.softphone);
  const { duration, status, contactId } = useSelector(store => store.telephony);
  const { firstName, lastName, carrierPermissions  } = useSelector(store => store.agent);
  const agentName = <span className="text-capitalize">{firstName} {lastName}</span>;

  // use cookie to store cross window state that can be read from
  //  other open instances of enrollment portal
  useEffect(() => {
    sendSoftphoneStatus(status);
  }, [status]);

  // try to make sure that call gets closed if window is closed
  useEffect(() => {
    window.addEventListener('beforeunload', () => {
      updateAgentStatus('Offline');
      endCall();
      connectLogout();
    });
    const watchShopperInfoInterval = setInterval(() => {
      const cookieCountyFips = getCookie('countyFips');
      const cookieEffectiveDate = getCookie('effectiveDate');
      if (cookieCountyFips !== countyFips) {
        setCountyFips(cookieCountyFips);
      }
      if (cookieEffectiveDate !== effectiveDate) {
        setEffectiveDate(cookieEffectiveDate);
      }
    }, 1000);
  }, []);

  // We need to update the agent portal with whatever the current
  // contact id is so that it can be used to associate voice soas
  // with calls.
  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage({ contactId, status }, agentPortalUrl);
    }
  }, [contactId, status]);

  return (
    <div className="container">
      <div className="row p-2">
        <div className="d-flex col">
          <b className="me-1">Outbound call -</b>
          {shopperName}
        </div>
        <div className="w-100" />
        <div className="d-flex col mt-1">
          Phone number: {prettifyPhone(phone)}
        </div>

        <div className="w-100" />
        <div className="d-flex col mt-1">
        </div>

        <div className="w-100" />
        <div className="d-flex col mt-3 align-items-center">
          <MicTestButton className="rounded-pill me-2" text="Test" />
          <MuteButton />
          <CallButton />
          <span className="mx-4">
            {duration ? moment(duration).format('mm:ss') : '--:--'}
          </span>
          <EndCallButton />
        </div>

        <div className="w-100" />
        <div className="d-flex col mt-3">
          <i>
            You MUST read aloud the language below within the first minute of the call.
          </i>
        </div>

        <div className="w-100" />
        <div className="d-flex col mt-3">
          <div
            type="button"
            className="form-check"
          >
            <input
              id="disclaimer"
              className="form-check-input"
              type="checkbox"
              checked={disclaimerRead}
              onChange={() => {
                setDisclaimerRead(!disclaimerRead);
              }}
            />
            <label
              className="form-check-label"
              htmlFor="disclaimer"
            >
              I have read the following language
            </label>
          </div>
        </div>
        <div className="w-100" />
      </div>
      {!disclaimerRead && (
        <div className="row tpmo-disclaimer h-100">
          <div className="d-flex col mb-4 mt-3">
            <p>
              Hi {shopperName}, this is {agentName} calling from a recorded line.
              <TPMODisclaimer
                planYear={planYear}
                carrierPermissions={carrierPermissions}
                countyFips={countyFips}
                selfAttest={!countyFips}
              />
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Softphone;
